<page-title [title]="title"></page-title>
<p>O que você deseja consultar?</p>
<div class="col-xs-6 col-md-3 col-md-offset-3">
    <mat-toolbar color="primary" class="center-card" (click)="goToUrl('agendar')">
        <mat-toolbar-row><mat-icon>local_hospital</mat-icon></mat-toolbar-row>
        <mat-toolbar-row>Agendar</mat-toolbar-row>
    </mat-toolbar>
</div>
<div class="col-xs-6 col-md-3">
    <mat-toolbar color="primary" class="center-card"  (click)="goToUrl('agenda/status')">
        <mat-toolbar-row><mat-icon>monitor_heart</mat-icon></mat-toolbar-row>
        <mat-toolbar-row>Status</mat-toolbar-row>
    </mat-toolbar>
</div>

